export default {
  methods: {
    formatMoney (value, clean = false) {
      return parseFloat(value)
          .toLocaleString('nl', {style: 'currency', currency: 'EUR'})
          .replace(',00', clean ? '' : ',-');
    },

    filterRound (value, decimals = 0) {
      return parseFloat(value).toFixed(decimals);
    },

    filterPercentage (value, decimals = 0) {
      return this.filterRound(value, decimals) + '%';
    },
  },
};
